import DatePicker from './DatePicker'
import MonthPicker from './MonthPicker'
import RangePicker from './RangePicker'

DatePicker.MonthPicker = MonthPicker
DatePicker.RangePicker = RangePicker

export default DatePicker
